import { Region } from 'constants/shop';
import { getRegionConfig } from 'config';

interface HreflangEntry {
  hreflang: string;
  path?: string;
}

/**
 * Per-shop-region hreflang table. DE domain also exposes the English UI path.
 */
const HREFLANG_CONFIG: Partial<Record<Region, HreflangEntry[]>> = {
  [Region.DE]: [{ hreflang: 'de' }, { hreflang: 'en', path: '/en' }, { hreflang: 'x-default' }],
  [Region.CH]: [{ hreflang: 'de-CH' }, { hreflang: 'x-default' }],
  [Region.NL]: [{ hreflang: 'nl' }, { hreflang: 'x-default' }],
};

/**
 * Generate hreflang URLs based on the shop region/domain configuration.
 */
export const getHreflangUrls = ({
  asPath,
  region,
}: {
  asPath: string;
  region: Region;
}): { hreflang: string; href: string }[] => {
  const entries = HREFLANG_CONFIG[region];

  if (!entries) {
    return [];
  }

  const { shopDomain } = getRegionConfig(region);

  return entries.map(({ hreflang, path = '' }) => ({
    hreflang,
    href: `https://${shopDomain}${path}${asPath}`,
  }));
};
